import React, { useEffect, useState, useRef, useCallback } from 'react';
import Column from './Column.js';
import { DragDropContext, Droppable } from '@hello-pangea/dnd';
import axios from 'axios';
import { useDispatch } from 'react-redux';
import { AddColumnCall, columnIndex, getAllColumns } from '../Redux/slice.js';
import services from '../services/index.js';
import { columnsLocal } from '../utils/LocalSt.js';
import email from '../api/email.js';
import { GET_ALL_USER } from '../utils/Apifunction.js';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { useSelector } from 'react-redux';
import AddColumnModal from './AddBoard/AddColumnModal.js';
import TableData from './Table/TableData.js';
import DatePlan from './Date/DatePlan.js';
import { debounce } from 'lodash';
import { getAllDateTableTask } from '../Redux/GetSlice.js';
import { useTaskData } from '../hooks/useTaskData.js';
import { toast } from 'react-toastify';
import { PrivilegesChecker } from '../utils/PrivilegesChecker.js';
import { getLocalStorageItem } from '../utils/Localstorage/localStorageUtils.js';

function ColumnContainer({
    handleAddColumn,
    columnAddStatus,
    setColumnAddStatus,
    getTaskMailIndbox,
    filterList,
    selectedBoardId,
    moveColumn,
    taskMail,
    setTaskMail,
    getTaskMail,
    removeTask,
    setSortBy,
    setSortOrder,
    sortby,
    getAllBoard,
    sortOrder,
    activeButton,
    moveTask,
    isArchivedBoard,
    boardName,
    isMember,
    parentOrigin,
    columnAutomation,
    allCustomFieldList,
    setAllCustomFieldList,
    getAllAutomation,
    columns, // Add columns to props
    userList
}) {
    const [statusUpdate, setStatusUpdate] = useState(true);
    const [taskDetailsPopup, setTaskDetailsPopup] = useState(false);
    const [taskAssign, setTaskAssign] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [isShiftPressed, setIsShiftPressed] = useState(false);
    const { isTableVisible, isDateVisible } = useSelector(
        (state) => ({
            isTableVisible: state.redux.isTableVisible,
            isDateVisible: state.redux.isDateVisible,
        }),
        (prev, next) =>
            prev.isTableVisible === next.isTableVisible &&
            prev.isDateVisible === next.isDateVisible,
    );
    const dispatch = useDispatch();
    const [conData, setConData] = useState(columnsLocal());
    const [selectedMyDayPlanDate, setSelectedMyDayPlanDate] = useState({
        myDayPlan: null,
        deadline: null,
        isAll: 'both',
    });
    const [selectedReminderDate, setSelectedReminderDate] = useState(null);
    const [selectedStatusNextStepDate, setSelectedStatusNextStepDate] = useState(null);
    const [notesText, setNotesText] = useState('');
    const [myDayDate, setMyDayDate] = useState(null);
    const [deadlineDate, setDeadlineDate] = useState(null);

    const [isMyDayChecked, setIsMyDayChecked] = useState(true);
    const [isDeadlineChecked, setIsDeadlineChecked] = useState(true);
    const [taskPage, setTaskPage] = useState(1);
    const [hasMoreTasks, setHasMoreTasks] = useState(true);
    const isLoadingMoreRef = useRef(false);
    const [note, setNote] = useState('');
    const [isAccess, setIsAccess] = useState([])
    const getTaskAssign = async () => {
        try {
            const page = 1;
            const falsePagination = true;
            const response = await services.userassignboard.GET_ASSIGN_USER_BY_BOARD_ID(selectedBoardId, searchTerm, falsePagination, page);
            const allData = response?.data?.data || [];
            const uniqueUsers = Array.from(
                new Map(allData.map(item => [item.userId, item.User])).values()
            ).filter(Boolean);
            
            setIsAccess(allData);
            setTaskAssign(uniqueUsers);
        } catch (error) {
            console.error("Error in getTaskAssign:", error);
        }
    };
    const userDataRaw = getLocalStorageItem("userData");
    let userData;
    if (typeof userDataRaw === "string") {
        try {
            userData = JSON.parse(userDataRaw);
        } catch {
            userData = null;
        }
    } else {
        userData = userDataRaw;
    }
    const role = userData?.role;
    const userId = userData?.id;
    useEffect(() => {
        getTaskAssign();
    }, [searchTerm, selectedBoardId]);
    const debouncedSequenceUpdate = debounce((sequenceData) => {
        services.board
            .SEQUENCE(sequenceData, selectedBoardId)
            .catch((e) => console.error('Sequence update error:', e));
    }, 300);

    const columnMove = (fromIndex, toIndex) => {
        dispatch(columnIndex({ from: fromIndex, to: toIndex }));
        const updatedColumns = [...columns];
        const [movedColumn] = updatedColumns.splice(fromIndex, 1);
        updatedColumns.splice(toIndex, 0, movedColumn);

        const sequenceData = updatedColumns.map((col, index) => ({
            id: col.id,
            sequence: index + 1,
        }));

        debouncedSequenceUpdate(sequenceData);
    };
    const moveChildTask = async (dragItem, dropItem, parentTaskStatus) => {
        const childTask = dragItem?.item || dragItem;
        const newParentTask = dropItem;

        if (newParentTask && childTask.id !== newParentTask.id && childTask.isTaskDependency) {
            try {
                const response = await services.task.GET_TASK_DEPENDENCIES(childTask.id);
                const dependencies = response.data.data;
                if (dependencies && dependencies.length > 0) {
                    for (const dep of dependencies) {
                        if (dep.dependerId === childTask.id) {
                            await services.task.CREATE_DEPENDENCY({
                                dependerId: newParentTask.id,
                                dependencyId: dep.dependencyId,
                            });
                            await services.task.DELETE_DEPENDENCY(dep.id);
                        }
                    }
                    toast.info(
                        `Dependencies moved from ${childTask.subject || childTask.title} to ${newParentTask.subject || newParentTask.title
                        }`,
                    );
                }
            } catch (error) {


            }
        }

        const childId = dragItem?.item?.id || dragItem?.id;
        const parentId = dropItem?.id || '';

        const parentData = {
            parentTaskID: parentId,
            parentTaskStatus: !parentTaskStatus,
            taskId: childId
        };
        try {
            // Passing parentId to the URL as expected by the API definition (parentId)
            // and including childTaskId/taskId in the body
            await services.task.UPDATE_CHILD_TASK(parentId || childId, parentData);
            getTaskMail(1, '', selectedBoardId);
        } catch (e) {
            console.error(e);
        }
    };

    const handleRemoveChild = (itemid, parentDataId, columnID, item) => {
        moveChildTask(item, '', true);
    };
    const {
        updateSelectedMyDayPlanDate,
        updateSelectedReminderDate,
        updateSelectedStatusNextStepDate,
        updateNote,
        updateNotesText,
        updateMyDayDate,
        updateDeadlineDate,
        updateIsMyDayChecked,
        updateIsDeadlineChecked,
        handleDateSelect,
        handleUpdateTask,
        resetAllTaskData,
    } = useTaskData();

    const [editTaskTitle, setEditTaskTitle] = useState();
    const [selectedTaskcolor, setSelectedTaskcolor] = useState('');
    const [isOpen, setIsOpen] = useState(false);
    const [taskDeleteId, setTaskDeleteId] = useState('');
    const [openTaskId, setOpenTaskId] = useState(null);
    const columnRef = useRef(null);
    const toggleTaskDropdown = (id, item) => {
        setEditTaskTitle(item?.subject || item?.title);
        setSelectedTaskcolor(id);
        setTaskDeleteId(id);
        setIsOpen(!isOpen);
        setOpenTaskId((prevId) => (prevId === id ? null : id));
    };

    const [showBox, setShowBox] = useState(false);
    const [isSearchBoxOpen, setIsSearchBoxOpen] = useState(false);
    const [hoverIndex, setHoverIndex] = useState();

    const [colorIndexID, setColorIndexID] = useState();
    const [activePatch, setActivePatch] = useState(null);
    const [updateTitle, setUpdateTitle] = useState(false);
    const [isOpenDeadline, setIsOpenDeadline] = useState(false);

    const [taskToDelete, setTaskToDelete] = useState(null);

    const handleCancelDelete = () => {
        setTaskToDelete(null);
        setShowBox(false);
    };
    const handleEditTitle = () => {
        setUpdateTitle(true);
        setIsOpen(!isOpen);
        setIsOpenDeadline(false);
    };

    const clearHighlight = () => {
        handleTaskSelectedColor('');
    };

    const handleClick = () => {
        setIsOpen(false);
    };
    const handleTaskSelectedColor = async (selectedColor) => {
        const data = {
            color: selectedColor,
        };
        try {
            const response = await axios.put(
                `${process.env.REACT_APP_BACKEND_URL}/task/updateTask/${selectedTaskcolor}`,
                data,
            );
            getTaskMail();
            setIsSearchBoxOpen(false);
        } catch (error) {
            console.error('Error:', error);
        }
    };

    const deleteTaskMail = async () => {
        try {
            const response = await services.task.DELETE_TASK(taskDeleteId || taskToDelete);
            if (response) {
                getTaskMail();
                const data = {
                    boardId: selectedBoardId,
                };
                dispatch(getAllDateTableTask({ data }));
                setShowBox(false);
            }
        } catch (error) {
            console.error('Error fetching task emails:', error);
        }
    };
    const loadMoreTasks = useCallback(() => {
        if (isLoadingMoreRef.current || !hasMoreTasks) return;

        isLoadingMoreRef.current = true;
        const nextPage = taskPage + 1;

        getTaskMail(nextPage, { append: true })
            .then(res => {
                if (!res) return;

                // 🔴 HARD STOP if empty data
                if (res.noMoreData || nextPage >= res.totalPages) {
                    setHasMoreTasks(false);
                    return;
                }

                setTaskPage(nextPage);
            })
            .finally(() => {
                isLoadingMoreRef.current = false;
            });
    }, [taskPage, hasMoreTasks, getTaskMail]);




    useEffect(() => {
        setTaskPage(1);
        setHasMoreTasks(true);
        isLoadingMoreRef.current = false;

        getTaskMail(1);
    }, [selectedBoardId]);

    const onDragEnd = (result) => {
        const { destination, source, draggableId, type } = result;

        if (!destination) return;

        if (
            destination.droppableId === source.droppableId &&
            destination.index === source.index
        ) {
            return;
        }

        // Handle column reordering
        if (type === 'COLUMN') {
            columnMove(source.index, destination.index);
            return;
        }

        // Handle task movement
        const sourceColumnId = source.droppableId;
        const destinationColumnId = destination.droppableId;
        const taskId = draggableId;

        // Find the task object from the taskMail state
        const sourceTasks = taskMail[sourceColumnId] || [];
        const movedTask = sourceTasks[source.index];

        if (!movedTask) return;

        if (sourceColumnId === destinationColumnId) {
            // Reordering within the same column
            const updatedTasks = [...sourceTasks];
            updatedTasks.splice(source.index, 1);
            updatedTasks.splice(destination.index, 0, movedTask);

            setTaskMail((prev) => ({
                ...prev,
                [sourceColumnId]: updatedTasks,
            }));

            // Call the API to update sequence
            moveTaskAction(taskId, sourceColumnId, destination.index, updatedTasks);
        } else {
            // Moving to another column
            const targetTasks = taskMail[destinationColumnId] || [];

            const newSourceTasks = [...sourceTasks];
            newSourceTasks.splice(source.index, 1);

            const newTargetTasks = [...targetTasks];
            newTargetTasks.splice(destination.index, 0, movedTask);

            setTaskMail((prev) => ({
                ...prev,
                [sourceColumnId]: newSourceTasks,
                [destinationColumnId]: newTargetTasks,
            }));

            // Call the API to update column and sequence
            moveTaskAction(taskId, destinationColumnId, destination.index, newTargetTasks);
        }
    };

    const moveTaskAction = async (taskId, toColumnId, toIndex, updatedTasks) => {
        let beforeTaskId = null;
        let afterTaskId = null;

        if (toIndex === 0) {
            beforeTaskId = updatedTasks[1]?.id || null;
        } else if (toIndex === updatedTasks.length - 1) {
            afterTaskId = updatedTasks[updatedTasks.length - 2]?.id || null;
        } else {
            afterTaskId = updatedTasks[toIndex - 1]?.id || null;
            beforeTaskId = updatedTasks[toIndex + 1]?.id || null;
        }

        const payload = {
            taskId: taskId,
            beforeTaskId,
            afterTaskId,
            boardListId: toColumnId,
        };

        try {
            await services.task?.MOVE_TASK_DRAG_DROP(payload);
            if (selectedBoardId) {
                // Optionally refresh if needed, but we already updated local state
                // getTaskMail(1, {}, selectedBoardId);
            }
        } catch (error) {
            console.error('❌ Error in moveTaskAction:', error);
            // Revert state if needed
            getTaskMail(1, {}, selectedBoardId);
        }
    };

    return (
        <div
            ref={columnRef}
            className="overflow-x-auto h-[93dvh] 2xl:h-[94dvh] 3xl:h-[93dvh]  min-h-[400px]"
            style={{
                overflowX: 'auto',
                whiteSpace: 'nowrap',
                overflowY: 'hidden',
                width: '100%',
                minWidth: '100%',
            }}

        >

            {isTableVisible === true ? (
                <TableData
                    columns={columns}
                    moveChildTask={moveChildTask}
                    taskMail={taskMail}
                    getTaskMailIndbox={getTaskMailIndbox}
                    getTaskMail={getTaskMail}
                    selectedBoardId={selectedBoardId}
                    setSortBy={setSortBy}
                    setSortOrder={setSortOrder}
                    sortby={sortby}
                    sortOrder={sortOrder}
                    userList={userList}
                />
            ) : isDateVisible === true ? (
                <DatePlan
                    myDayDate={myDayDate}
                    setMyDayDate={setMyDayDate}
                    handleUpdateTask={handleUpdateTask}
                    selectedBoardId={selectedBoardId}
                    getTaskMail={getTaskMail}
                    deadlineDate={deadlineDate}
                    setDeadlineDate={setDeadlineDate}
                    handleDateSelect={handleDateSelect}
                    toggleTaskDropdown={toggleTaskDropdown}
                    isDateModal={isOpen}
                    showBox={showBox}
                    setShowBox={setShowBox}
                    setIsSearchBoxOpen={setIsSearchBoxOpen}
                    setHoverIndex={setHoverIndex}
                    setColorIndexID={setColorIndexID}
                    setActivePatch={setActivePatch}
                    hoverIndex={hoverIndex}
                    colorIndexID={colorIndexID}
                    activePatch={activePatch}
                    removeTask={removeTask}
                    handleEditTitle={handleEditTitle}
                    clearHighlight={clearHighlight}
                    handleClick={handleClick}
                    setUpdateTitle={setUpdateTitle}
                    updateTitle={updateTitle}
                    setIsOpenDeadline={setIsOpenDeadline}
                    isOpenDeadline={isOpenDeadline}
                    isSearchBoxOpen={isSearchBoxOpen}
                    handleTaskSelectedColor={handleTaskSelectedColor}
                    taskToDelete={taskToDelete}
                    setTaskToDelete={setTaskToDelete}
                    handleCancelDelete={handleCancelDelete}
                    userList={userList}
                />
            ) : (
                <div
                    style={{
                        display: 'flex',
                        height: '100%',
                        width: 'max-content',
                        minWidth: '100%',
                    }}
                    className="column__container colum-border border-[2px] mt-[-8px]"
                >
                    <Droppable droppableId="all-columns" direction="horizontal" type="COLUMN">
                        {(provided) => (
                            <div
                                {...provided.droppableProps}
                                ref={provided.innerRef}
                                style={{
                                    display: 'flex',
                                    gap: '1px',
                                    height: '100%',
                                }}
                            >
                                {columns?.length > 0 && columns?.map((column, index) => (
                                    <Column
                                        isMember={isMember}
                                        parentOrigin={parentOrigin}
                                        key={column?.id}
                                        id={column?.id}
                                        columnTitle={column?.title}
                                        limit={column?.limit}
                                        borderColor={column?.borderColor}
                                        setStatusUpdate={setStatusUpdate}
                                        statusUpdate={statusUpdate}
                                        setTaskDetailsPopup={setTaskDetailsPopup}
                                        taskDetailsPopup={taskDetailsPopup}
                                        getTaskMail={getTaskMail}
                                        taskMail={taskMail}
                                        taskAssign={taskAssign}
                                        setSearchTerm={setSearchTerm}
                                        index={index}
                                        columnMove={columnMove}
                                        columnID={column?.id}
                                        searchTerm={searchTerm}
                                        isShiftPressed={isShiftPressed}
                                        moveChildTask={moveChildTask}
                                        handleRemoveChild={handleRemoveChild}
                                        setIsShiftPressed={setIsShiftPressed}
                                        setConData={setConData}
                                        setColumnAddStatus={setColumnAddStatus}
                                        selectedMyDayPlanDate={selectedMyDayPlanDate}
                                        setSelectedMyDayPlanDate={setSelectedMyDayPlanDate}
                                        selectedReminderDate={selectedReminderDate}
                                        setSelectedReminderDate={setSelectedReminderDate}
                                        selectedStatusNextStepDate={selectedStatusNextStepDate}
                                        setSelectedStatusNextStepDate={setSelectedStatusNextStepDate}
                                        note={note}
                                        setNote={setNote}
                                        handleDateSelect={handleDateSelect}
                                        myDayDate={myDayDate}
                                        deadlineDate={deadlineDate}
                                        isMyDayChecked={isMyDayChecked}
                                        isDeadlineChecked={isDeadlineChecked}
                                        setIsMyDayChecked={setIsMyDayChecked}
                                        setIsDeadlineChecked={setIsDeadlineChecked}
                                        notesText={notesText}
                                        setNotesText={setNotesText}
                                        setMyDayDate={setMyDayDate}
                                        setDeadlineDate={setDeadlineDate}
                                        handleUpdateTask={handleUpdateTask}
                                        columnDetails={columns}
                                        selectedBoardId={selectedBoardId}
                                        toggleTaskDropdown={toggleTaskDropdown}
                                        editTaskTitle={editTaskTitle}
                                        setEditTaskTitle={setEditTaskTitle}
                                        selectedTaskcolor={selectedTaskcolor}
                                        setSelectedTaskcolor={setSelectedTaskcolor}
                                        isOpen={isOpen}
                                        setIsOpen={setIsOpen}
                                        taskDeleteId={taskDeleteId}
                                        openTaskId={openTaskId}
                                        showBox={showBox}
                                        setShowBox={setShowBox}
                                        setIsSearchBoxOpen={setIsSearchBoxOpen}
                                        setHoverIndex={setHoverIndex}
                                        setColorIndexID={setColorIndexID}
                                        setActivePatch={setActivePatch}
                                        hoverIndex={hoverIndex}
                                        colorIndexID={colorIndexID}
                                        activePatch={activePatch}
                                        handleEditTitle={handleEditTitle}
                                        clearHighlight={clearHighlight}
                                        handleClick={handleClick}
                                        setUpdateTitle={setUpdateTitle}
                                        updateTitle={updateTitle}
                                        setIsOpenDeadline={setIsOpenDeadline}
                                        isOpenDeadline={isOpenDeadline}
                                        isSearchBoxOpen={isSearchBoxOpen}
                                        handleTaskSelectedColor={handleTaskSelectedColor}
                                        deleteTask={deleteTaskMail}
                                        taskToDelete={taskToDelete}
                                        setTaskToDelete={setTaskToDelete}
                                        handleCancelDelete={handleCancelDelete}
                                        setTaskMail={setTaskMail}
                                        getAllBoard={getAllBoard}
                                        activeButton={activeButton}
                                        onColumnScrollEnd={loadMoreTasks}
                                        boardName={boardName}
                                        filterList={filterList}
                                        columnAutomation={columnAutomation}
                                        allCustomFieldList={allCustomFieldList}
                                        setAllCustomFieldList={setAllCustomFieldList}
                                        getAllAutomation={getAllAutomation}
                                        userList={userList}
                                    />
                                ))}
                                {provided.placeholder}
                            </div>
                        )}
                    </Droppable>

                    {
                        selectedBoardId &&
                        (isAccess.some(item => item.isMember !== true) || role === 'admin') &&
                        PrivilegesChecker('Add a List') && (
                            <div className="" style={{ width: '60px', minWidth: '60px', display: 'flex', alignItems: 'flex-start', paddingTop: '10px', marginLeft: '10px' }}>
                                <div className="task task-curve" style={{ width: '100%', margin: '0', padding: '10px' }}>
                                    <button
                                        style={{ opacity: '0.3', width: '100%' }}
                                        className="add-task-button"
                                        onClick={() => {
                                            dispatch(AddColumnCall());
                                            setColumnAddStatus(true);
                                        }}
                                    >
                                        <FontAwesomeIcon icon={faPlus} />
                                    </button>
                                </div>
                            </div>
                        )}


                    {columnAddStatus && (
                        <AddColumnModal
                            show={columnAddStatus}
                            onHide={() => setColumnAddStatus(false)}
                            handleAddColumn={handleAddColumn}
                        />
                    )}
                </div>
            )}
        </div>
    );
}

export default ColumnContainer;
